module.exports = __webpack_public_path__ + "img/HappyPhoto31.c293b1ca.jpeg";